
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { useCollections } from "@/contexts/collections";

const DeleteCollectionDialog = () => {
  const { operation, closeOperation, handleCollectionDeleted } = useCollections();
  const { user } = useAuth();
  
  const isOpen = operation.isOpen && operation.type === "delete";
  const collection = operation.collection;

  if (!collection) {
    return null;
  }

  const handleOpenChange = (open: boolean) => {
    console.log('[DeleteCollectionDialog] handleOpenChange called with:', open);
    if (!open) {
      closeOperation();
      
      // TEMPORARY FIX: Force page refresh when dialog is closed
      setTimeout(() => {
        console.log('[DeleteCollectionDialog] Forcing page refresh after dialog close');
        window.location.reload();
      }, 100);
    }
  };

  const handleDelete = async () => {
    if (!user) {
      toast.error("You must be logged in to delete a collection");
      closeOperation();
      return;
    }

    try {
      console.log('[DeleteCollectionDialog] handleDelete called');
      // Close the dialog first
      closeOperation();
      
      const { error } = await supabase
        .from("collections")
        .delete()
        .eq("id", collection.id)
        .eq("user_id", user.id);

      if (error) throw error;
      
      // Show success message
      toast.success(`Collection "${collection.name}" deleted successfully`);
      
      // Notify parent
      handleCollectionDeleted();
      
      // TEMPORARY FIX: Force page refresh after deletion
      setTimeout(() => {
        console.log('[DeleteCollectionDialog] Forcing page refresh after delete');
        window.location.reload();
      }, 100);
    } catch (error) {
      console.error("Error deleting collection:", error);
      toast.error("Failed to delete collection");
      
      // TEMPORARY FIX: Force page refresh even on error
      setTimeout(() => {
        console.log('[DeleteCollectionDialog] Forcing page refresh after error');
        window.location.reload();
      }, 100);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Collection</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{collection.name}"? This will also remove all content associations to this collection.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 focus:bg-red-600 text-white"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteCollectionDialog;
